import {IConfig} from '../interfaces/reducers/IConfig'

class Config {
  protected config: IConfig
  setConfig(config: IConfig) {
    this.config = config
  }
  getConfig(): IConfig {
    return this.config
  }
}

const config = new Config()

export {config}
